import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/vin_blacklists',
  component: Management,
  redirect: '/vin_blacklists/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/vin_blacklists/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listVinBlacklists
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/vin_blacklists/ListTable'),
          meta: {
            auth: Auth.listVinBlacklists,
            tabName: 'all'
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/vin_blacklists/New'),
      meta: {
        auth: Auth.createVinBlacklist
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/vin_blacklists/Edit'),
      meta: {
        auth: Auth.updateVinBlacklist
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/vin_blacklists/DetailLayout'),
      meta: {
        auth: Auth.showVinBlacklist
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/vin_blacklists/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showVinBlacklist
          }
        }
      ]
    }
  ]
}
